import {CreateGuesser} from "@api-platform/admin";
import {MedicalCaseForm} from "../components/MedicalCaseForm";

export const MedicalCaseCreate = props => (
    <CreateGuesser {...props}>
        <MedicalCaseForm />
    </CreateGuesser>
);
